import React, { useState, useEffect } from "react";
import {
  CalendarIcon,
  CheckIcon,
  CogIcon,
  DownloadIcon,
  SearchIcon,
  XCircleIcon,
} from "@heroicons/react/solid";
import {
  Form,
  Button,
  InputGroup,
  Dropdown,
  Nav,
  Card,
  Table,
  Pagination,
  Tab,
} from "react-bootstrap";
import {
  useCampaignSummaryReportsMutation,
  useCDRforSmsMutation,
  useChannelOverviewMutation,
  useDnld_SMS_CDRMutation,
  useDnldCampMutation,
  useDnldChannelInsightsMutation,
  useDnldErrorCodesMutation,
  useDnldScheduledCampMutation,
  useErrorCodeSummaryMutation,
  useScheduledCampMutation,
} from "Services/services";
import moment from "moment-timezone";
import Datetime from "react-datetime";
import hasPermission from "pages/Permissions";
import { downloadBlobFile } from "components/Utility";
import Select from 'react-select';

export default () => {
  // Get the user type from localStorage :: UI
  const userData = localStorage.getItem("TOKEN");
  const userObject = JSON.parse(userData);
  const userID = userObject.id;

  // affects API response as well as data Table
  const [tabType, setTabType] = useState("tab1");

  const [tableData, setTableData] = useState([]);

  // const [bulkOption, setBulkOption] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [filterOptions, setFilterOptions] = useState([]);
  const [filterValue, setFilterValue] = useState("");
  const [statusOptions, setStatusOptions] = useState([]);
  const [statusValue, setStatusValue] = useState("");
  const [start, setStart] = useState(null);
  const [end, setEnd] = useState(null);

  const [pagelimit, setPagelimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [totalPosts, setTotalPosts] = useState(0);
  const [debouncedValue, setDebouncedValue] = useState("");

  const [CampaignList] = useCampaignSummaryReportsMutation();
  const [channelInsights] = useChannelOverviewMutation();
  const [errorCodes] = useErrorCodeSummaryMutation();
  const [viewCDR] = useCDRforSmsMutation();
  const [scheduled] = useScheduledCampMutation();
  const [dnldCamp] = useDnldCampMutation();
  const [dnldChannelInsight] = useDnldChannelInsightsMutation();
  const [dnldCDRreport] = useDnld_SMS_CDRMutation();
  const [dnldErrorCodes] = useDnldErrorCodesMutation();
  const [dnldScheduled] = useDnldScheduledCampMutation();




  // Debounce search value
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(searchValue); // Set debounced value after 3 seconds
    }, 2000);
    // Cleanup the timeout if searchValue changes (to avoid multiple timeouts)
    return () => {
      clearTimeout(handler);
    };
  }, [searchValue]);


  const getStatusOptions = (tabType) => {
    switch (tabType) {
      case ("tab3"):
        return [
          { value: "delivered", label: "Delivered" },
          { value: "failed", label: "Failed" },
          { value: "in-process", label: "In-process" }
        ];
      case "tab5":
        return [
          { value: "blocked", label: "Blocked" },
          { value: "active", label: "Active" },
        ];
      case "tab6":
        return [
          { value: "pending", label: "Pending" },
          { value: "paused", label: "Paused" },
          { value: "cancelled", label: "Cancelled" },
          { value: "approved", label: "Approved" },
          { value: "rejected", label: "Rejected" },
          { value: "inprocess", label: "In-Process" },
          { value: "running", label: "Running" },
          { value: "completed", label: "Completed" },
        ];
      default:
        return [];
    }
  };

  const getFilterOptions = (tabType) => {
    switch (tabType) {
      case ("tab3"):
        return [
          { value: "Transactional", label: "Transactional" },
          { value: "Promotional", label: "Promotional" },
          { value: "OTP", label: "OTP" },
          { value: "ANY", label: "Any" }
        ];
      default:
        return [];
    }
  };

  const fetchCampaign = async () => {
    try {
      const response = await CampaignList({
        page: currentPage,
        limit: pagelimit,
        campaignType: "SMS",
        search: searchValue,
        startDate: start ? start.format("YYYY-MM-DD") : "",
        endDate: end ? end.format("YYYY-MM-DD") : "",
      });

      if (response?.data?.statusCode === 200) {
        setTableData(response?.data?.data?.items || []);
        setTotalPages(Math.ceil(response?.data?.data?.totalItems / pagelimit));
        setTotalPosts(response?.data?.data?.totalItems || 0);
      } else {
        setTableData([]);
        setTotalPages(0);
        setTotalPosts(0);
      }
    } catch (error) {
      alert(error.message);
      setTableData([]);
      setTotalPages(0);
      setTotalPosts(0);
    }
  };
  // const fetchChannelInsights = async () => {
  //   try {
  //     const response = await channelInsights({
  //       user_id: userID,
  //       startDate: startDate,
  //       endDate: endDate,
  //     });
  //     if (response?.data?.statusCode === 200) {
  //       const obj = response?.data?.data?.smsPercentage || {};
  //       setTableData([obj]);
  //       setTotalPages("1");
  //       setTotalPosts("1");
  //     }
  //     else {
  //       setTableData([]);
  //       setTotalPages(0);
  //       setTotalPosts(0);
  //     }
  //   } catch (error) {
  //     setTableData([]);
  //     setTotalPages(0);
  //     setTotalPosts(0);
  //   }
  // };
  const fetchErrorCodes = async () => {
    try {
      const response = await errorCodes({
        page: currentPage,
        limit: pagelimit,
        campaignType: "SMS",
        startDate: start ? start.format("YYYY-MM-DD") : "",
        endDate: end ? end.format("YYYY-MM-DD") : "",
        search: searchValue
      });

      if (response?.data?.statusCode === 200) {
        setTableData(response?.data?.data?.items || []);
        setTotalPages(Math.ceil(response?.data?.data?.totalItems / pagelimit));
        setTotalPosts(response?.data?.data?.totalItems || 0);
      } else {
        setTableData([]);
        setTotalPages(0);
        setTotalPosts(0);
      }
    } catch (error) {
      alert(error.message);
      setTableData([]);
      setTotalPages(0);
      setTotalPosts(0);
    }
  };
  const fetchCDRs = async () => {
    try {
      const response = await viewCDR({
        search: searchValue,
        status: statusValue,
        sender_type: filterValue,
        startDate: start ? start.format("YYYY-MM-DD") : "",
        endDate: end ? end.format("YYYY-MM-DD") : "",
        page: currentPage,
        limit: pagelimit
      });
      if (response?.data?.statusCode === 200) {
        setTableData(response?.data?.data?.items || []);
        setTotalPages(Math.ceil(response?.data?.data?.totalItems / pagelimit));
        setTotalPosts(response?.data?.data?.totalItems || 0);
      } else {
        console.warn('No data available.');
        setTableData([]);
        setTotalPages(0);
        setTotalPosts(0);
      }
    } catch (error) {
      alert(error.message);
      setTableData([]);
      setTotalPages(0);
      setTotalPosts(0);
    }
  };
  const fetchScheduled = async () => {
    try {
      const response = await scheduled({
        page: currentPage,
        limit: pagelimit,
        search: searchValue,
        campaignType: "SMS",
        status: statusValue,
        startDate: start ? start.format("YYYY-MM-DD") : "",
        endDate: end ? end.format("YYYY-MM-DD") : "",
      });

      if (response?.data?.statusCode === 200) {
        setTableData(response?.data?.data?.items || []);
        setTotalPages(Math.ceil(response?.data?.data?.totalItems / pagelimit));
        setTotalPosts(response?.data?.data?.totalItems || 0);
      } else {
        setTableData([]);
        setTotalPages(0);
        setTotalPosts(0);
      }
    } catch (error) {
      alert(error.message);
      setTableData([]);
      setTotalPages(0);
      setTotalPosts(0);
    }
  };
  const dnldCampaign = async () => {
    try {
      const blob = await dnldCamp({
        campaignType: "SMS",
        search: searchValue,
        loggedin_user_id: userID,
        user_type_id: userObject.user_type_id || "1",
        startDate: start ? start.format("YYYY-MM-DD") : "",
        endDate: end ? end.format("YYYY-MM-DD") : "",
      }).unwrap();
      downloadBlobFile(blob, "SMS_Campaigns.csv");
    } catch (err) {
      if (err?.status === 404) alert("No data found.");
      else alert("Download failed.");
    }
  };
  const dnldCDR = async () => {
    try {
      const blob = await dnldCDRreport({
        search: searchValue,
        status: statusValue,
        sender_type: filterValue,
        loggedin_user_id: userID,
        user_type_id: userObject.user_type_id || "1",
        startDate: start ? start.format("YYYY-MM-DD") : "",
        endDate: end ? end.format("YYYY-MM-DD") : "",
      }).unwrap();
      downloadBlobFile(blob, "SMS_CDRs.csv");
    } catch (err) {
      if (err?.status === 404) alert("No data found.");
      else alert("Download failed.");
    }
  };
  // const dnldChannelIns = async () => {
  //   try {
  //     const blob = await dnldChannelInsight({
  //       loggedin_user_id: userID,
  //       user_type_id: userObject.user_type_id || "1",
  //       startDate: startDate,
  //       endDate: endDate,
  //     }).unwrap();
  //     downloadBlobFile(blob, "SMS_Channel_Insights.csv");
  //   } catch (err) {
  //     if (err?.status === 404) alert("No data found.");
  //     else alert("Download failed.");
  //   }
  // };
  const dnldError = async () => {
    try {
      const blob = await dnldErrorCodes({
        loggedin_user_id: userID,
        user_type_id: userObject.user_type_id || "1",
        campaignType: "SMS",
        startDate: start ? start.format("YYYY-MM-DD") : "",
        endDate: end ? end.format("YYYY-MM-DD") : "",
        search: searchValue
      }).unwrap();
      downloadBlobFile(blob, "SMS_Error_Report.csv");
    } catch (err) {
      if (err?.status === 404) alert("No data found.");
      else alert("Download failed.");
    }
  };
  const dnldScheduledCamps = async () => {
    try {
      const blob = await dnldScheduled({
        loggedin_user_id: userID,
        user_type_id: userObject.user_type_id || "1",
        search: searchValue,
        campaignType: "SMS",
        status: statusValue,
        startDate: start ? start.format("YYYY-MM-DD") : "",
        endDate: end ? end.format("YYYY-MM-DD") : "",
      }).unwrap();
      downloadBlobFile(blob, "SMS_Scheduled_Campaigns.csv");
    } catch (err) {
      if (err?.status === 404) alert("No data found.");
      else alert("Download failed.");
    }
  };


  useEffect(() => {
    if (tabType === "tab1") {
      fetchCampaign();
    }
    // else if (tabType === "tab2") {
    //   fetchChannelInsights();
    // } 
    else if (tabType === "tab3") {
      fetchCDRs();
    } else if (tabType === "tab4") {
      fetchErrorCodes();
    } else if (tabType === "tab6") {
      fetchScheduled();
    }

  }, [
    currentPage,
    pagelimit,
    debouncedValue,
    start,
    end,
    tabType,
    statusValue,
    filterValue,
  ]);

  useEffect(() => {
    setPagelimit(10);
    setCurrentPage(1);
    setSearchValue('');
    setDebouncedValue('');
    setStart(null);
    setEnd(null);
    setFilterValue('');
    setStatusOptions(getStatusOptions(tabType));
    setFilterOptions(getFilterOptions(tabType));
    setTotalPages(0);
    setTotalPosts(0);
  }, [tabType]);

  const changeSearchValue = (e) => {
    setSearchValue(e.target.value);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handlePrev = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };

  const handleNext = () => {
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const canDownload = hasPermission("SMS Reports", "download");
  const handleDownload = () => {
    if (tabType === "tab1") {
      dnldCampaign();
    }
    //  else if (tabType === "tab2") {
    //   dnldChannelIns();
    // } 
    else if (tabType === "tab3") {
      dnldCDR();
    } else if (tabType === "tab4") {
      dnldError();
    } else if (tabType === "tab6") {
      dnldScheduledCamps();
    } else {
      return;
    }
  }

  const TableRow = (props) => {

    switch (tabType) {
      case "tab1": {
        return (
          <tr className="border-bottom">
            <td><span className="fw-normal" title={props.campaign_name || "-"}>{props.campaign_name}</span></td>
            <td><span className="fw-normal" title={props.totalSubmitted || "-"}>{props.totalSubmitted}</span></td>
            <td><span className="fw-normal" title={props.totalSuccess || "-"}>{props.totalSuccess}</span></td>
            <td><span className="fw-normal" title={props.totalFailure || "-"}>{props.totalFailure}</span></td>
            <td><span className="fw-normal" title={moment(props.time).format('DD/MM/YYYY') || '-'}>{moment(props.time).format('DD/MM/YYYY') || '-'}</span></td>
            <td><span className="fw-normal" title={props.totalDeductAmount || "-"}>{props.totalDeductAmount}</span></td>
          </tr>
        );
      }
      // case "tab2":
      //   {
      //     return (
      //       <tr className="border-bottom">
      //         <td><span className="fw-normal">{props.submitted + '%' || '-'}</span></td>
      //         <td><span className="fw-normal">{props.failure + '%' || '-'}</span></td>
      //         <td><span className="fw-normal">{props.success + '%' || '-'}</span></td>
      //         <td><span className="fw-normal">{props.read + '%' || '-'}</span></td>
      //         <td><span className="fw-normal">{props.processing + '%' || '-'}</span></td>
      //       </tr>
      //     );
      //   }
      case "tab3":
        {
          return (
            <tr className="border-bottom">
              <td><span className="fw-normal" title={props.sender || '-'}>{props.sender || '-'}</span></td>
              <td><span className="fw-normal" title={props.receiver || '-'}>{props.receiver || '-'}</span></td>
              <td><span className="fw-normal" title={props.campaign || '-'}>{props.campaign || '-'}</span></td>

              <td><span className="fw-normal" title={props.content || '-'}>{props.content || '-'}</span></td>
              <td><span className="fw-normal" title={moment(props.submit_time).format('DD/MM/YYYY') || '-'}>{moment(props.submit_time).format('DD/MM/YYYY') || '-'}</span></td>
              <td><span className="fw-normal" title={props.message_id || '-'}>{props.message_id || '-'}</span></td>
              <td><span className="fw-normal" title={props.foreign_id || '-'}>{props.foreign_id || '-'}</span></td>
              <td><span className="fw-normal" title={props.account || '-'}>{props.account || '-'}</span></td>
              <td><span className="fw-normal" title={props.user || '-'}>{props.user || '-'}</span></td>
              <td><span className="fw-normal" title={props.userid || '-'}>{props.userid || '-'}</span></td>
              <td><span className="fw-normal" title={props.smsc || '-'}>{props.smsc || '-'}</span></td>
              <td><span className="fw-normal" title={props.parts || '-'}>{props.parts || '-'}</span></td>
              <td><span className="fw-normal" title={props.entity_id || '-'}>{props.entity_id || '-'}</span></td>
              <td><span className="fw-normal" title={props.content_id || '-'}>{props.content_id || '-'}</span></td>
              <td><span className="fw-normal" title={props.httpid || '-'}>{props.httpid || '-'}</span></td>
              <td><span className="fw-normal" title={props.status || '-'}>{props.status || '-'}</span></td>
              <td><span className="fw-normal" title={props.reason || '-'}>{props.reason || '-'}</span></td>
              <td><span className="fw-normal" title={props.masked_reason || '-'}>{props.masked_reason || '-'}</span></td>
              <td><span className="fw-normal" title={props.masked_status || '-'}>{props.masked_status || '-'}</span></td>
              <td><span className="fw-normal" title={props.err_description || '-'}>{props.err_description || '-'}</span></td>
              <td><span className="fw-normal" title={moment(props.done_date).format('DD/MM/YYYY') || '-'}>{moment(props.done_date).format('DD/MM/YYYY') || '-'}</span></td>
              <td><span className="fw-normal" title={props.encoding || '-'}>{props.encoding || '-'}</span></td>
              <td><span className="fw-normal" title={props.sender_type || '-'}>{props.sender_type || '-'}</span></td>
              <td><span className="fw-normal" title={props.channel || '-'}>{props.channel || '-'}</span></td>
            </tr>
          );
        }
      case "tab4":
        {
          return (
            <tr className="border-bottom">
              <td><span className="fw-normal" title={props.code || '-'} style={{ maxWidth: "250px" }}>{props.code || '-'}</span></td>
              <td><span className="fw-normal" title={props.totalCount || '-'}>{props.totalCount || '-'}</span></td>
              <td><span className="fw-normal" title={moment(props.createdAt).format('DD/MM/YYYY') || '-'}>{moment(props.createdAt).format('DD/MM/YYYY') || '-'}</span></td>
              <td><span className="fw-normal" title={props.totalDeductAmount || '-'}>{props.totalDeductAmount || '-'}</span></td>
            </tr>
          );
        }
      case "tab5":
        {
          return (
            <tr className="border-bottom">
              <td><span className="fw-normal" title={props.totalDeductAmount || '-'}>{props.totalDeductAmount || '-'}</span></td>
              <td><span className="fw-normal" title={props.code || '-'}>{props.code || '-'}</span></td>
              <td><span className="fw-normal" title={props.totalCount || '-'}>{props.totalCount || '-'}</span></td>
              <td><span className="fw-normal" title={moment(props.time).format('DD/MM/YYYY') || '-'}>{moment(props.time).format('DD/MM/YYYY') || '-'}</span></td>
              <td><span className="fw-normal" title={moment(props.createdAt).format('DD/MM/YYYY') || '-'}>{moment(props.createdAt).format('DD/MM/YYYY') || '-'}</span></td>
            </tr>
          );
        }
      case "tab6":
        {
          return (
            <tr className="border-bottom">
              <td><span className="fw-normal" title={props.campaign_name || '-'}>{props.campaign_name || '-'}</span></td>
              <td><span className="fw-normal" title={moment(props.scheduledTime).format('DD/MM/YYYY') || '-'}>{moment(props.scheduledTime).format('DD/MM/YYYY') || '-'}</span></td>
              <td><span className="fw-normal" title={props.actualSentTime || '-'}>{props.actualSentTime || '-'}</span></td>
              <td><span className="fw-normal" title={props.scheduled_type || '-'}>{props.scheduled_type || '-'}</span></td>
              <td><span className="fw-normal" title={props.status || '-'}>{props.status || '-'}</span></td>
            </tr>
          );
        }
      default: {
        return null;
      }
    }
  };

  return (
    <>
      <Card className="p-2">
        <Tab.Container
          defaultActiveKey={tabType}
          onSelect={(key) => {
            setTabType(key);
          }}
        >
          <Nav fill variant="pills" className="flex-lg-nowrap gap-2">
            <Nav.Item>
              <Nav.Link eventKey="tab1">Campaign Overview</Nav.Link>
            </Nav.Item>
            {/* <Nav.Item>
                <Nav.Link eventKey="tab2">Channel Insights</Nav.Link>
              </Nav.Item> */}
            <Nav.Item>
              <Nav.Link eventKey="tab3">CDR Report</Nav.Link>
            </Nav.Item>
            <Nav.Item>
              <Nav.Link eventKey="tab4">Error Report</Nav.Link>
            </Nav.Item>
            {/* <Nav.Item>
                <Nav.Link eventKey="tab5">Cost & Billing Report</Nav.Link>
              </Nav.Item> */}
            <Nav.Item>
              <Nav.Link eventKey="tab6">Scheduled Campaign Log</Nav.Link>
            </Nav.Item>
          </Nav>
        </Tab.Container>
      </Card>

      <Card border={1}>
        <div className="d-flex flex-wrap align-items-center gap-2 mb-3">
          {tabType !== "tab2" && tabType !== "tab5" && <InputGroup className="d-flex flex-nowrap fmxw-500">
            <InputGroup.Text>
              <SearchIcon className="icon icon-xs" />
            </InputGroup.Text>
            <Form.Control
              type="search"
              placeholder=
              {tabType === "tab1" ? "Search Campaign-Name" :
                tabType === "tab3" ? "Search Campaign Name/Contact" :
                  tabType === "tab4" ? "Search Code" :
                    (tabType === "tab4" || tabType === "tab6") ? "Search Campaign-Name" :
                      "Search"}
              value={searchValue}
              onChange={changeSearchValue}
            />
          </InputGroup>}
          {tabType !== "tab2" && 
           <Form.Group id="DateRange">
           <InputGroup className="d-flex flex-nowrap">
             <InputGroup.Text
               onClick={() => {
                 setStart(null);
                 setEnd(null);
               }}
             >
               {start || end ? (
                 <XCircleIcon className="icon icon-xs" />
               ) : (
                 <CalendarIcon className="icon icon-xs" />
               )}
             </InputGroup.Text>
             <Datetime
               timeFormat={false}
               onChange={(date) => {
                 if (moment.isMoment(date)) {
                   setStart(date);
                 }
               }}
               closeOnSelect={true}
               renderInput={(props, openCalendar) => (
                 <Form.Control
                   type="search"
                   placeholder="Start Date"
                   value={
                     start ? moment(start).format("DD/MM/YYYY") : ""
                   }
                   onFocus={openCalendar}
                   readOnly
                   style={{ width: "150px", borderRadius: "0" }}
                 />
               )}
             />
             <Datetime
               timeFormat={false}
               onChange={(date) => {
                 if (moment.isMoment(date)) {
                   setEnd(date);
                 }
               }}
               closeOnSelect={true}
               isValidDate={(currDate) => currDate.isAfter(start)}
               initialViewDate={end}
               renderInput={(props, openCalendar) => (
                 <Form.Control
                   type="search"
                   placeholder="End Date"
                   value={end ? moment(end).format("DD/MM/YYYY") : ""}
                   onFocus={openCalendar}
                   readOnly
                   style={{
                     width: "150px",
                     borderTopLeftRadius: "0",
                     borderBottomLeftRadius: "0",
                   }}
                 />
               )}
             />
           </InputGroup>
         </Form.Group>
          }

          {tabType !== "tab1" && tabType !== "tab2" && tabType !== "tab4" && (
            <div className="fix-200">
              <Select
                options={statusOptions}
                value={statusOptions.find(option => option.value === statusValue)}
                onChange={(selectedOption) => setStatusValue(selectedOption?.value || '')}
                placeholder="Select Status"
                isClearable
                className="react-select"
              />
            </div>
          )}

          {tabType === "tab3" && (
            <div className="fix-200">
              <Select
                options={filterOptions} // same array you used earlier
                value={filterOptions.find(option => option.value === filterValue)} // react-select expects the whole object
                onChange={(selectedOption) => setFilterValue(selectedOption?.value || '')}
                placeholder="Select Sender Type"
                isClearable
                className="react-select"
              />
            </div>
          )}

          <div className="ms-auto d-flex gap-2">
            {canDownload && (
              <Button
                variant="outline-gray-300"
                className="d-inline-flex p-2 dnld"
                onClick={handleDownload}
              >
                <DownloadIcon className="icon icon-sm" />
              </Button>
            )}

            <Dropdown>
              <Dropdown.Toggle
                split
                as={Button}
                variant="outline-gray-300"
                className="text-dark m-0 p-2"
              >
                <CogIcon className="icon icon-sm" />
                <span className="visually-hidden">
                  Toggle Dropdown
                </span>
              </Dropdown.Toggle>
              <Dropdown.Menu className="dropdown-menu-xs dropdown-menu-end p-2">
                <span className="small ps-2 fw-bold text-dark">
                Rows per page
                </span>
                {[10, 20, 30].map((limit) => (
                  <Dropdown.Item
                    key={limit}
                    className={`d-flex align-items-center fw-bold ${limit === 30 ? "rounded-bottom" : ""
                      }`}
                    onClick={() => {
                      setPagelimit(limit); // Update the page limit
                      setCurrentPage(1); // Reset the page number to 1
                    }}
                  >
                    {limit}{" "}
                    {pagelimit === limit && (
                      <CheckIcon className="icon icon-xxs ms-auto" />
                    )}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>

        <div className="custom-scroll-wrapper">
          <div className="scroll-container">
            <Table responsive className="align-items-center table-flush table-outlines">
              <thead className="thead-light">
                {tabType === 'tab1' ?
                  <tr>
                    <th className="border-bottom">Campaign Name</th>
                    <th className="border-bottom">Total Sent</th>
                    <th className="border-bottom">Delivered</th>
                    <th className="border-bottom">Failed</th>
                    <th className="border-bottom">Date</th>
                    <th className="border-bottom">Cost</th>
                  </tr>
                  // : tabType === 'tab2' ?
                  //   <tr>
                  //     <th className="border-bottom">Submitted</th>
                  //     <th className="border-bottom">Failure</th>
                  //     <th className="border-bottom">Success</th>
                  //     <th className="border-bottom">Read</th>
                  //     <th className="border-bottom">In-Process</th>
                  //   </tr>
                  : tabType === 'tab3' ?
                    <tr>
                      <th className="border-bottom">Sender</th>
                      <th className="border-bottom">Contact</th>
                      <th className="border-bottom">Campaign Name</th>
                      <th className="border-bottom">Content</th>
                      <th className="border-bottom">Submit Time</th>
                      <th className="border-bottom">Message ID</th>
                      <th className="border-bottom">Foreign ID</th>
                      <th className="border-bottom">Account</th>
                      <th className="border-bottom">User</th>
                      <th className="border-bottom">User ID</th>
                      <th className="border-bottom">SMSC</th>
                      <th className="border-bottom">Parts</th>
                      <th className="border-bottom">Entity ID</th>
                      <th className="border-bottom">Content ID</th>
                      <th className="border-bottom">HTTP ID</th>
                      <th className="border-bottom">Status</th>
                      <th className="border-bottom">Reason</th>
                      <th className="border-bottom">Masked Reason</th>
                      <th className="border-bottom">Masked Status</th>
                      <th className="border-bottom">Err Description</th>
                      <th className="border-bottom" style={{minWidth:'120px'}}>Done Date</th>
                      <th className="border-bottom">Encoding</th>
                      <th className="border-bottom">Sender Type</th>
                      <th className="border-bottom">Channel</th>
                    </tr> : tabType === 'tab4' ?
                      <tr>
                        <th className="border-bottom">Code</th>
                        <th className="border-bottom">Total Count</th>
                        <th className="border-bottom">Created On</th>
                        <th className="border-bottom">Deducted Amount</th>
                      </tr> : tabType === 'tab5' ?
                        <tr>
                          <th className="border-bottom">Date</th>
                          <th className="border-bottom">Total Sent</th>
                          <th className="border-bottom">Billed</th>
                          <th className="border-bottom">Cost</th>
                          <th className="border-bottom">Avg Cost/SMS</th>
                        </tr> :
                        <tr>
                          <th className="border-bottom">Campaign Name</th>
                          <th className="border-bottom">Scheduled Date</th>
                          <th className="border-bottom">Scheduled Time</th>
                          <th className="border-bottom">Scheduled Type</th>
                          <th className="border-bottom">Status</th>
                        </tr>
                }
              </thead>
              <tbody className="border-0">
                {tableData.length > 0 ? (
                  tableData.map((u, index) => (
                    <TableRow key={index + 1} index={index + 1} {...u} />
                  ))
                ) : (
                  <tr>
                    <td colSpan={tabType === 'tab1' ? 6 : tabType === 'tab2' ? 5 : tabType === 'tab3' ? 25 : (tabType === 'tab5' || tabType === 'tab6') ? 5 : 4} className="text-center text-danger">
                      No Data Found
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>
        </div>

        <Card.Footer className="p-0 mt-3 border-0 d-flex flex-wrap align-items-center justify-content-between">
          <Nav>
            <Pagination className="mb-0">
              <Pagination.Prev
                onClick={handlePrev}
                disabled={currentPage === 1}
              >
                Previous
              </Pagination.Prev>
              {currentPage >= 3 && (
                <>
                  <Pagination.Item onClick={() => handlePageChange(1)}>
                    1
                  </Pagination.Item>
                  <Pagination.Ellipsis />
                </>
              )}
              {currentPage > 1 && (
                <Pagination.Item
                  onClick={() => handlePageChange(currentPage - 1)}
                >
                  {currentPage - 1}
                </Pagination.Item>
              )}
              <Pagination.Item active>{currentPage}</Pagination.Item>
              {currentPage < totalPages && (
                <Pagination.Item
                  onClick={() => handlePageChange(currentPage + 1)}
                >
                  {currentPage + 1}
                </Pagination.Item>
              )}
              {currentPage < totalPages - 1 && (
                <>
                  <Pagination.Ellipsis />
                  <Pagination.Item
                    onClick={() => handlePageChange(totalPages)}
                  >
                    {totalPages}
                  </Pagination.Item>
                </>
              )}
              <Pagination.Next
                onClick={handleNext}
                disabled={currentPage === totalPages}
              >
                Next
              </Pagination.Next>
            </Pagination>
          </Nav>
          <small className="fw-normal small mt-2 mt-md-0">
            Showing <b>{totalPosts == 0 ? totalPosts : pagelimit * (currentPage - 1) + 1}-{(pagelimit * currentPage) > totalPosts ? totalPosts : (pagelimit * currentPage)}</b> of <b>{totalPosts}</b>{" "}entries.
          </small>
        </Card.Footer>
      </Card>
    </>
  );
};
